import Rate from "@/components/Rate"
import { useIsMobile } from "@/hooks/use-is-mobile"

export const MaybeRating = ({
  rating_summary,
  review_count,
  showReview,
}: {
  rating_summary: number
  review_count: number
  showReview: boolean
}) => {
  const { isMobile } = useIsMobile()

  if (!showReview) {
    return null
  }

  if (!review_count) {
    return null
  }

  return (
    <div className="flex items-center">
      <Rate disabled initialRating={rating_summary / 20} />
      <span className="ml-[10px] font-sans text-sm leading-[1.4] text-[#666]">
        {review_count} {!isMobile && <span>Reviews</span>}
      </span>
    </div>
  )
}
